import React, { Component, ReactNode } from 'react';
import { DinoGrid } from '@uchi/ui-lib-react';
import './Grid.css';

interface Props {
  children: ReactNode,
  className?: string,
  id?: string,
}

class Grid extends Component<Props> {
  private static MAX_COLS = 12;
  
  private static DESKTOP_TRESHOLD = 1024;

  static itemClass(cols = 1, offset = 0): string {
    const klasses = [`grid-item-${cols}`];
    if (cols > this.MAX_COLS) throw new Error(`Grid supports only ${this.MAX_COLS}`);
    if (cols < 0) throw new Error('Column count can not be negative');
    if (offset > this.MAX_COLS - 1) throw new Error(`Offset is too big, max is ${this.MAX_COLS - 1}`);
    if (offset < 0) throw new Error(`Negative offset unsupported, was given: ${offset}`);
    if (offset) klasses.push(`grid-offset-${offset}`);
    return klasses.join(' ');
  }
  
  static isMobile(): boolean {
    return window.innerWidth < this.DESKTOP_TRESHOLD;
  }

  render(): JSX.Element {
    const { children, className } = this.props;
    return (
      <DinoGrid className={className}>
        {children}
      </DinoGrid>
    );
  }
}

export default Grid;
